import { BestTimeToPostChartController } from './BestTimeToPostChart.controller';
import React, { useContext } from 'react';
import { gql } from '@apollo/client';
import { useGetBestTimePostStatsQuery } from '../../../../../models/graphql';
import { AnalyticsContext } from '../../../AnalyticsProvider';

gql`
  query GetBestTimePostStats($socialProfileId: ID!) {
    analyticsBestTimeToPostStats(socialProfileId: $socialProfileId) {
      postEngagementByDayOfWeek {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      postEngagementByHourOfDay {
        hour0
        hour1
        hour2
        hour3
        hour4
        hour5
        hour6
        hour7
        hour8
        hour9
        hour10
        hour11
        hour12
        hour13
        hour14
        hour15
        hour16
        hour17
        hour18
        hour19
        hour20
        hour21
        hour22
        hour23
      }
    }
  }
`;
export const BestTimeToPostChartApollo = () => {
  const { selectedProfilesIds } = useContext(AnalyticsContext);
  const { data, loading } = useGetBestTimePostStatsQuery({ variables: { socialProfileId: selectedProfilesIds[0] } });
  return <BestTimeToPostChartController data={data} loading={loading} />;
};
